import Analytics from '@jg/koala-front-end-analytics';
import config from 'config/config';

let clientAnalytics;

function getKoalaClient() {
  if (!clientAnalytics) {
    clientAnalytics = new Analytics({ apiUrl: config.KOALA_API_URI });
  }
  return clientAnalytics;
}

function trackKoala(trackedInfo) {
  const analytics = getKoalaClient();
  return analytics.track({ ...trackedInfo });
}

export default {
  track(event) {
    trackKoala(event);
  },
};



// WEBPACK FOOTER //
// ./utils/analytics/analytics.js